import { useState, useMemo, useEffect } from 'react';
import { Briefcase, TrendingUp, CheckCircle, XCircle } from 'lucide-react';
import { LeadsTable } from '../../components/LeadsTable';
import { LeadFilters } from '../../components/LeadFilters';
import { LeadCard } from '../../components/LeadCardAdmin';
import { CallAPIDeletePromise, CallAPIGetPromise } from 'Common/commaon';
import { Toaster, toast } from 'sonner';
import { AdminLeadsShimmer } from 'components/shimmer';
import './all-leads.css';

interface Lead {
  id: string;
  title: string;
  category: string;
  tradesmens_commission: string;
  description: string;
  budget: number;
  location: {
    address: string;
    city: string;
    state: string;
    zipCode: string;
  };
  lead_sub_cat: string;
  postedDate: string;
  status: string;
  homeowner: {
    id: number;
    name: string;
    email: string;
    phone: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    pic: string;
    memberSince: string;
    completedProjects: number;
  };
  images: string[];
  media: Array<{
    type: string;
    url: string;
  }>;
  activities?: Array<{
    id: string;
    type: 'status_change' | 'assigned' | 'note' | 'created';
    description: string;
    timestamp: string;
    user: string;
  }>;
}

// Mock data
const INITIAL_LEADS: Lead[] = [
  {
    "id": "206",
    "title": "Electrician",
    "category": "Electrician",
    "tradesmens_commission": "49",
    "description": "Add additional outlet in kitchen for refrigerator, examine breaker, additional outlets through out t",
    "budget": 10000,
    "location": {
      "address": "35 Rappallo Ave ",
      "city": "Middletown",
      "state": "CT",
      "zipCode": "06457"
    },
    "lead_sub_cat": "Change outlet switches, service call",
    "postedDate": "2024-12-28T10:33:02.010Z",
    "status": "declined",
    "homeowner": {
      "id": 485,
      "name": "jennifer Mascaro",
      "email": "jenimascaro@gmail.com",
      "phone": "8605588993",
      "address": "",
      "city": "",
      "state": "",
      "zipCode": "",
      "pic": "",
      "memberSince": "2024-12-27T19:03:47.985Z",
      "completedProjects": 0
    },
    "images": [
      "https://images.unsplash.com/photo-1654440122140-f1fc995ddb34?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
    ],
    "media": [
      {
        "type": "image",
        "url": "https://images.unsplash.com/photo-1654440122140-f1fc995ddb34?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
      }
    ],
    "activities": [
      {
        "id": "1",
        "type": "created",
        "description": "Lead created by homeowner",
        "timestamp": "2024-12-28T10:33:02.010Z",
        "user": "jennifer Mascaro"
      },
      {
        "id": "2",
        "type": "status_change",
        "description": "Status changed from pending to active",
        "timestamp": "2024-12-28T11:15:00.000Z",
        "user": "Admin"
      },
      {
        "id": "3",
        "type": "assigned",
        "description": "Assigned to John Smith (Electrician)",
        "timestamp": "2024-12-28T14:30:00.000Z",
        "user": "Admin"
      },
      {
        "id": "4",
        "type": "status_change",
        "description": "Status changed from active to declined",
        "timestamp": "2024-12-29T09:00:00.000Z",
        "user": "Admin"
      }
    ]
  },
  {
    "id": "247",
    "title": "Plumber",
    "category": "Plumber",
    "tradesmens_commission": "450",
    "description": "W/d drain install move pipes and install sink shower. ",
    "budget": 2000,
    "location": {
      "address": "94 Washington st\n",
      "city": "Norwalk",
      "state": "Ct",
      "zipCode": "06854"
    },
    "lead_sub_cat": "Bathroom remodel",
    "postedDate": "2025-03-20T04:25:01.088Z",
    "status": "active",
    "homeowner": {
      "id": 844,
      "name": "Chris  Buswell",
      "email": "Chris@doawalkthru.com",
      "phone": "2033251617",
      "address": "",
      "city": "",
      "state": "",
      "zipCode": "",
      "pic": "",
      "memberSince": "2025-03-20T10:40:10.152Z",
      "completedProjects": 0
    },
    "images": [
      "https://images.unsplash.com/photo-1654440122140-f1fc995ddb34?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
    ],
    "media": [
      {
        "type": "image",
        "url": "https://images.unsplash.com/photo-1654440122140-f1fc995ddb34?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
      }
    ],
    "activities": [
      {
        "id": "1",
        "type": "created",
        "description": "Lead created by homeowner",
        "timestamp": "2025-03-20T04:25:01.088Z",
        "user": "Chris Buswell"
      },
      {
        "id": "2",
        "type": "status_change",
        "description": "Status changed to active",
        "timestamp": "2025-03-20T05:00:00.000Z",
        "user": "Admin"
      }
    ]
  },
  {
    "id": "248",
    "title": "Plumber",
    "category": "Plumber",
    "tradesmens_commission": "109",
    "description": "W/d drain install move pipes and install sink shower. ",
    "budget": 2000,
    "location": {
      "address": "94 Washington st\n",
      "city": "Norwalk",
      "state": "Ct",
      "zipCode": "06854"
    },
    "lead_sub_cat": "Bathroom remodel",
    "postedDate": "2025-03-20T04:25:01.088Z",
    "status": "pending",
    "homeowner": {
      "id": 844,
      "name": "Chris  Buswell",
      "email": "Chris@doawalkthru.com",
      "phone": "2033251617",
      "address": "",
      "city": "",
      "state": "",
      "zipCode": "",
      "pic": "",
      "memberSince": "2025-03-20T10:40:10.152Z",
      "completedProjects": 0
    },
    "images": [
      "https://images.unsplash.com/photo-1654440122140-f1fc995ddb34?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
    ],
    "media": [
      {
        "type": "image",
        "url": "https://images.unsplash.com/photo-1654440122140-f1fc995ddb34?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
      }
    ],
    "activities": [
      {
        "id": "1",
        "type": "created",
        "description": "Lead created by homeowner",
        "timestamp": "2025-03-20T04:25:01.088Z",
        "user": "Chris Buswell"
      }
    ]
  },
  {
    "id": "275",
    "title": "Electrician",
    "category": "Electrician",
    "tradesmens_commission": "49",
    "description": "An outlet caught fire. Wantvto switch out all the outlets in the living room. Approximately 4. ",
    "budget": 300,
    "location": {
      "address": "381 union city rd ",
      "city": "Naugatuck ",
      "state": "Ct",
      "zipCode": "06770"
    },
    "lead_sub_cat": "Change outlet switches, service call",
    "postedDate": "2025-03-29T01:14:19.832Z",
    "status": "declined",
    "homeowner": {
      "id": 839,
      "name": "Lancerous  Arrington",
      "email": "Arringtonl1@yahoo.com",
      "phone": "2037729075",
      "address": "",
      "city": "",
      "state": "",
      "zipCode": "",
      "pic": "",
      "memberSince": "2025-03-20T10:28:04.795Z",
      "completedProjects": 0
    },
    "images": [
      "https://images.unsplash.com/photo-1654440122140-f1fc995ddb34?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
    ],
    "media": [
      {
        "type": "image",
        "url": "https://images.unsplash.com/photo-1654440122140-f1fc995ddb34?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=1080"
      }
    ],
    "activities": [
      {
        "id": "1",
        "type": "created",
        "description": "Lead created by homeowner",
        "timestamp": "2025-03-29T01:14:19.832Z",
        "user": "Lancerous Arrington"
      },
      {
        "id": "2",
        "type": "note",
        "description": "Admin added note: Urgent - fire hazard",
        "timestamp": "2025-03-29T02:00:00.000Z",
        "user": "Admin"
      },
      {
        "id": "3",
        "type": "status_change",
        "description": "Status changed to declined - customer found another contractor",
        "timestamp": "2025-03-29T10:00:00.000Z",
        "user": "Admin"
      }
    ]
  }
];

const AllLeads=()=> {
  const [leads, setLeads] = useState<Lead[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [viewMode, setViewMode] = useState<'table' | 'grid'>('table');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [budgetMin, setBudgetMin] = useState('');
  const [budgetMax, setBudgetMax] = useState('');
  const [zipCode, setZipCode] = useState('');
 const [refresh,setRefresh]=useState(false)
 const [loading,setLaoding]=useState(false)
  // Get unique categories
  const categories = useMemo(() => {
    return Array.from(new Set(leads.map(lead => lead.category)));
  }, [leads]);

  // Filter leads
  const filteredLeads = useMemo(() => {
    return leads.filter(lead => {
      const matchesSearch = 
        lead.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        lead.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        lead.homeowner.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        lead.location.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
        lead.id.includes(searchTerm);

      const matchesStatus = !statusFilter || lead.status === statusFilter;
      const matchesCategory = !categoryFilter || lead.category === categoryFilter;

      // Date range filter
      const leadDate = new Date(lead.postedDate);
      const matchesDateFrom = !dateFrom || leadDate >= new Date(dateFrom);
      const matchesDateTo = !dateTo || leadDate <= new Date(dateTo);

      // Budget range filter
      const matchesBudgetMin = !budgetMin || lead.budget >= parseFloat(budgetMin);
      const matchesBudgetMax = !budgetMax || lead.budget <= parseFloat(budgetMax);

      // Zip code filter
      const matchesZipCode = !zipCode || lead.location.zipCode.includes(zipCode);

      return matchesSearch && matchesStatus && matchesCategory && 
             matchesDateFrom && matchesDateTo && 
             matchesBudgetMin && matchesBudgetMax && 
             matchesZipCode;
    });
  }, [leads, searchTerm, statusFilter, categoryFilter, dateFrom, dateTo, budgetMin, budgetMax, zipCode]);

  // Calculate stats
  const stats = useMemo(() => {
    const totalLeads = leads.length;
    const activeLeads = leads.filter(l => l.status === 'accepted').length;
    const totalBudget = leads.reduce((sum, l) => sum + l.budget, 0);
    const totalCommission = leads.reduce((sum, l) => sum + parseFloat(l.tradesmens_commission), 0);
    
    return { totalLeads, activeLeads, totalBudget, totalCommission };
  }, [leads]);

  const handleUpdateLead = (leadId: string, updates: Partial<Lead>) => {
    setLeads(prevLeads =>
      prevLeads.map(lead => {
        if (lead.id === leadId) {
          const updatedLead = { ...lead, ...updates };
          
          // Add activity for status change
          if (updates.status && updates.status !== lead.status) {
            const newActivity = {
              id: Date.now().toString(),
              type: 'status_change' as const,
              description: `Status changed from ${lead.status} to ${updates.status}`,
              timestamp: new Date().toISOString(),
              user: 'Admin'
            };
            updatedLead.activities = [...(lead.activities || []), newActivity];
          }
          
          return updatedLead;
        }
        return lead;
      })
    );
  };

  const handleDeleteLead = async (leadId: string) => {
    try {
      const response: any = await CallAPIDeletePromise(`/jobs/admin/${leadId}`);
      setLeads(prevLeads => prevLeads.filter(lead => lead.id !== leadId));
      toast.success(response?.message || 'Lead deleted successfully');
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Unable to delete this lead');
    }
  };

  const handleApplyPreset = (preset: string) => {
    const today = new Date();
    const weekAgo = new Date(today);
    weekAgo.setDate(weekAgo.getDate() - 7);
    const monthAgo = new Date(today);
    monthAgo.setMonth(monthAgo.getMonth() - 1);

    switch (preset) {
      case 'today':
        setDateFrom(today.toISOString().split('T')[0]);
        setDateTo(today.toISOString().split('T')[0]);
        setBudgetMin('');
        setBudgetMax('');
        break;
      case 'week':
        setDateFrom(weekAgo.toISOString().split('T')[0]);
        setDateTo(today.toISOString().split('T')[0]);
        setBudgetMin('');
        setBudgetMax('');
        break;
      case 'month':
        setDateFrom(monthAgo.toISOString().split('T')[0]);
        setDateTo(today.toISOString().split('T')[0]);
        setBudgetMin('');
        setBudgetMax('');
        break;
      case 'high-value':
        setBudgetMin('5000');
        setBudgetMax('');
        setDateFrom('');
        setDateTo('');
        break;
    }
  };

  const handleClearFilters = () => {
    setSearchTerm('');
    setStatusFilter('');
    setCategoryFilter('');
    setDateFrom('');
    setDateTo('');
    setBudgetMin('');
    setBudgetMax('');
    setZipCode('');
  };

  useEffect(()=>{
    setLaoding(true)
CallAPIGetPromise("/jobs/jobList").then((res:any)=>{
if(res?.data){
  setLeads(res.data)
}
}).finally(()=>{
  setLaoding(false)

})
  },[refresh])

  return (
<div className='tailwind-prefix page-content all-leads-page'>
  {loading ?<AdminLeadsShimmer/> : <>
    <div
    style={{
      backgroundColor: "#ffffff",
      borderBottom: "1px solid #e5e7eb",
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    }}
    className='all-leads-header'
  >
    <div
      style={{
        margin: "0 auto",
        padding: "16px 0",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ display: "flex", gap: "8px", marginLeft: "auto" }}>
          <button
            onClick={() => setViewMode("table")}
            className={`all-leads-view-toggle ${viewMode === "table" ? "is-active" : ""}`}
            style={{
              padding: "8px 16px",
              border: "0px",
              borderRadius: "8px",
              fontSize: "14px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              backgroundColor: viewMode === "table" ? "#2563eb" : "#f3f4f6",
              color: viewMode === "table" ? "#ffffff" : "#374151",
              boxShadow:
                viewMode === "table"
                  ? "0 1px 2px rgba(0,0,0,0.1)"
                  : "none",
            }}
          >
            Table View
          </button>

          <button
            onClick={() => setViewMode("grid")}
            className={`all-leads-view-toggle ${viewMode === "grid" ? "is-active" : ""}`}
            style={{
              padding: "8px 16px",
              border: "0px",
              borderRadius: "8px",
              fontSize: "14px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              backgroundColor: viewMode === "grid" ? "#2563eb" : "#f3f4f6",
              color: viewMode === "grid" ? "#ffffff" : "#374151",
              boxShadow:
                viewMode === "grid"
                  ? "0 1px 2px rgba(0,0,0,0.1)"
                  : "none",
            }}
          >
            Grid View
          </button>
        </div>
      </div>
    </div>
  </div>

  {/* Stats */}
  <div
    style={{
      margin: "0 auto",
      paddingTop: "24px",
    }}
  >
    <div
      className="all-leads-stats-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
        gap: "16px",
        marginBottom: "24px",
      }}
    >
      {/* Total Leads */}
      <div
        className="all-leads-stat-card"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "10px",
          border: "1px solid #e5e7eb",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          padding: "16px",
          transition: "box-shadow 0.2s ease",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "12px",
          }}
        >
          <span style={{ fontSize: "14px", color: "#4b5563" }}>
            Total Leads
          </span>
          <div
            style={{
              backgroundColor: "#eff6ff",
              padding: "8px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Briefcase style={{ width: "20px", height: "20px", color: "#2563eb" }} />
          </div>
        </div>

        <div style={{ fontSize: "24px", color: "#111827", marginBottom: "4px" }}>
          {stats.totalLeads}
        </div>
        <div style={{ fontSize: "12px", color: "#6b7280" }}>All time</div>
      </div>

      {/* Active Leads */}
      <div
        className="all-leads-stat-card"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "10px",
          border: "1px solid #e5e7eb",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          padding: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "12px",
          }}
        >
          <span style={{ fontSize: "14px", color: "#4b5563" }}>
            Active Leads
          </span>
          <div
            style={{
              backgroundColor: "#ecfdf5",
              padding: "8px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckCircle style={{ width: "20px", height: "20px", color: "#16a34a" }} />
          </div>
        </div>

        <div style={{ fontSize: "24px", color: "#111827", marginBottom: "4px" }}>
          {stats.activeLeads}
        </div>
        <div style={{ fontSize: "12px", color: "#6b7280" }}>
          Ready to assign
        </div>
      </div>

      {/* Total Budget */}
      <div
        className="all-leads-stat-card"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "10px",
          border: "1px solid #e5e7eb",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          padding: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "12px",
          }}
        >
          <span style={{ fontSize: "14px", color: "#4b5563" }}>
            Total Budget
          </span>
          <div
            style={{
              backgroundColor: "#f5f3ff",
              padding: "8px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TrendingUp style={{ width: "20px", height: "20px", color: "#7c3aed" }} />
          </div>
        </div>

        <div style={{ fontSize: "24px", color: "#111827", marginBottom: "4px" }}>
          ${(stats.totalBudget / 1000).toFixed(1)}K
        </div>
        <div style={{ fontSize: "12px", color: "#6b7280" }}>Project value</div>
      </div>

      {/* Commission */}
      <div
        className="all-leads-stat-card"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "10px",
          border: "1px solid #e5e7eb",
          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          padding: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "12px",
          }}
        >
          <span style={{ fontSize: "14px", color: "#4b5563" }}>
            Commission
          </span>
          <div
            style={{
              backgroundColor: "#fffbeb",
              padding: "8px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TrendingUp style={{ width: "20px", height: "20px", color: "#d97706" }} />
          </div>
        </div>

        <div style={{ fontSize: "24px", color: "#111827", marginBottom: "4px" }}>
          ${stats.totalCommission.toLocaleString()}
        </div>
        <div style={{ fontSize: "12px", color: "#6b7280" }}>Total earnings</div>
      </div>
    </div>

    {/* Filters */}
    <LeadFilters
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      statusFilter={statusFilter}
      onStatusFilterChange={setStatusFilter}
      categoryFilter={categoryFilter}
      onCategoryFilterChange={setCategoryFilter}
      categories={categories}
      dateFrom={dateFrom}
      dateTo={dateTo}
      onDateFromChange={setDateFrom}
      onDateToChange={setDateTo}
      budgetMin={budgetMin}
      budgetMax={budgetMax}
      onBudgetMinChange={setBudgetMin}
      onBudgetMaxChange={setBudgetMax}
      zipCode={zipCode}
      onZipCodeChange={setZipCode}
      onApplyPreset={handleApplyPreset}
      onClearFilters={handleClearFilters}
    />

    {/* Results count */}
    <div
      className="all-leads-results-count"
      style={{
        marginBottom: "16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <div style={{ fontSize: "14px", color: "#4b5563" }}>
        Showing{" "}
        <span style={{ fontWeight: 600, color: "#111827" }}>
          {filteredLeads.length}
        </span>{" "}
        of{" "}
        <span style={{ fontWeight: 600, color: "#111827" }}>
          {leads.length}
        </span>{" "}
        leads
      </div>

      {filteredLeads.length > 0 && (
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <span style={{ fontSize: "14px", color: "#6b7280" }}>Sort by:</span>
          <select
            style={{
              padding: "6px 12px",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              fontSize: "14px",
              backgroundColor: "#ffffff",
              outline: "none",
            }}
          >
            <option>Latest First</option>
            <option>Highest Budget</option>
            <option>Highest Commission</option>
          </select>
        </div>
      )}
    </div>

    {/* Content */}
    <div
      className={viewMode === "table" ? "all-leads-table-surface" : "all-leads-grid-surface"}
      style={
        viewMode === "table"
          ? {
              backgroundColor: "#ffffff",
              borderRadius: "10px",
              border: "1px solid #e5e7eb",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
              overflow: "hidden",
            }
          : {}
      }
    >
      {filteredLeads.length === 0 ? (
        <div
          className="all-leads-empty"
          style={{
            textAlign: "center",
            padding: "64px 0",
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            border: "1px solid #e5e7eb",
            boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
          }}
        >
          <XCircle
            style={{
              width: "48px",
              height: "48px",
              color: "#d1d5db",
              margin: "0 auto 12px auto",
              display: "block",
            }}
          />
          <div style={{ fontSize: "18px", color: "#374151", marginBottom: "4px" }}>
            No leads found
          </div>
          <div style={{ fontSize: "14px", color: "#6b7280" }}>
            Try adjusting your filters
          </div>
        </div>
      ) : viewMode === "table" ? (
        <LeadsTable
          leads={filteredLeads}
          onUpdateLead={handleUpdateLead}
          onDeleteLead={handleDeleteLead}
          setRefresh={setRefresh}
        />
      ) : (
        <div
          className="all-leads-card-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gap: "16px",
          }}
        >
          {filteredLeads.map((lead) => (
            <LeadCard
              key={`${lead.id}-${lead.homeowner.id}`}
              lead={lead}
              onUpdateLead={handleUpdateLead}
              onDeleteLead={handleDeleteLead}
              setRefresh={setRefresh}
            />
          ))}
        </div>
      )}
    </div>
  </div>
  
  </>}
 
<Toaster position={"top-right"}/>
  <div style={{ height: "64px" }}></div>
</div>
  );
}

export default AllLeads
